exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-funnel-js {\n  display: inline-block;\n  position: relative;\n}\n.svg-funnel-js svg {\n  display: block;\n}\n.svg-funnel-js .svg-funnel-js__labels {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__labels {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}", ""]);

// exports
